export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";